/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EClassRoomDisciplinesStatus } from "../types/EClassRoomDisciplinesStatus.ts";

/**
 * @description 1 = Planned | 2 = Finished | 3 = Canceled | 4 = Confirmed |
 */
export const eClassRoomDisciplinesStatusSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
  .describe(
    "1 = Planned | 2 = Finished | 3 = Canceled | 4 = Confirmed | ",
  ) as unknown as ToZod<EClassRoomDisciplinesStatus>;
